var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDolrr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 111,
    viewBox: "0 0 264 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5024_3803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.723 52.8265V98.8325H222.772V52.8265C222.772 48.1289 226.596 44.3064 231.297 44.3064V27.2662C217.196 27.2662 205.723 38.7335 205.723 52.8265Z",
    fill: "#4318FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.426 52.8265V98.8325H255.475V52.8265C255.475 48.1289 259.297 44.3064 264 44.3064V27.2662C249.9 27.2662 238.426 38.7335 238.426 52.8265Z",
    fill: "#4318FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.295 0.127319H0V98.8357H40.295C59.3152 98.8357 74.7307 83.4251 74.7307 64.4179V34.5451C74.7307 15.5348 59.312 0.127319 40.295 0.127319ZM57.6848 63.164C57.6848 73.4536 49.3386 81.7955 39.0435 81.7955H17.0491V17.1643H39.0403C49.3354 17.1643 57.6816 25.5062 57.6816 35.7959V63.1576L57.6848 63.164Z",
    fill: "#4318FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.546 0H175.497V98.8357H192.546V0Z",
    fill: "#4318FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.488 26.5533H131.61V13.8416H116.073V26.5533H113.109C98.2759 26.5533 86.2485 38.5712 86.2485 53.3994V71.8845C86.2485 79.3289 89.2832 86.0635 94.1776 90.9235C99.0338 95.7453 105.721 98.7275 113.105 98.7275H116.07V110.997H131.607V98.7275H135.485C150.318 98.7275 162.345 86.7096 162.345 71.8814V53.3962C162.345 45.8882 159.253 39.109 154.283 34.2363C149.436 29.4877 142.806 26.5501 135.485 26.5501L135.488 26.5533ZM144.682 72.903C144.682 77.9126 140.618 81.9737 135.606 81.9737H112.991C110.462 81.9737 108.182 80.9361 106.536 79.2716C104.918 77.6325 103.915 75.3855 103.915 72.903V52.3809C103.915 47.3713 107.979 43.3102 112.991 43.3102H135.606C138.071 43.3102 140.297 44.3 141.93 45.8914C143.621 47.54 144.682 49.8348 144.682 52.3809V72.903Z",
    fill: "#4318FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5024_3803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 111,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDolrr);
export default __webpack_public_path__ + "static/media/logo_dolrr.df22d3f8b6114c2acdf6006d0c11ba75.svg";
export { ForwardRef as ReactComponent };